// src/ui/brand-logo.js — logo "Pacto Mundial" (2 líneas) para las pantallas
// pre-login. Reemplaza el <h1 class="title">PACTO MUNDIAL</h1> por la imagen.
//
// <picture>: WebP preferido (más liviano) con fallback PNG. Vite resuelve los
// imports a URLs de asset hasheadas (fuera del bundle JS). El texto "Pacto
// Mundial" se conserva en alt + aria-label (SEO / accesibilidad). El tamaño y
// centrado lo da la clase .brand-logo (css/styles.css): width:100% +
// max-width responsable + height:auto → escala proporcional, sin deformar.

import logoWebp from '../assets/logo-pm-2lineas@2x.webp'
import logoPng from '../assets/logo-pm-2lineas@2x.png'

export const renderBrandLogo = () => `
        <picture>
            <source srcset="${logoWebp}" type="image/webp">
            <img src="${logoPng}" class="brand-logo" alt="Pacto Mundial" aria-label="Pacto Mundial" width="600" height="235">
        </picture>`
